import type { AppDisplayModeType } from '@archipro-design/aria';
import type { Tracker } from '@archipro-website/tracker';
import type { CategoryTypes } from '../type';
import { getCategoryGridColumns } from '../type';

// TODO: add articles once we confirm the position rule of the articles page as the articles page is not a regular grid layout page.
type LogCategoryTypes = CategoryTypes;

interface LogDirectoryItemProps {
    itemID?: number;
    professionalID?: number;
    offset: number; // item offset in the list. start from 0
    categoryType: LogCategoryTypes;
    appDisplayMode: AppDisplayModeType;
}

/**
 * Log `directoryTileClick` event.
 * Rocco uses its own implementation as the grid is flexible
 */
export const logDirectoryItemClick = (
    tracker: Tracker,
    item: LogDirectoryItemProps
) => {
    const { itemID, professionalID, offset, categoryType, appDisplayMode } =
        item;
    const columnPerRow = getCategoryGridColumns(categoryType, appDisplayMode);
    const row = Math.floor(offset / columnPerRow) + 1; // start from 1
    const column = (offset % columnPerRow) + 1; // start from 1
    const pos = offset + 1; // start from 1

    tracker.log('directoryTileClick', {
        targetTracker: ['ga4Tracker', 'archiproTracker'],
        url: new URL(window.location.href),
        data: {
            LibraryItemID: itemID,
            ProfessionalID: professionalID,
            // format: Row,Column,CountPerRow,AbsolutePosition
            ExtraData: `${row},${column},${columnPerRow},${pos}`,
        },
    });
};
